/**
 * The household (Adresses.Status) values and their Dutch labels — one source
 * of truth for every status dropdown, counter, chart and aggregation.
 *
 * The order is the funnel the team works through: a household comes in, gets
 * called, waits for a callback, gets an appointment, and so on. Every status
 * chart renders its bars in this order, so changing it changes those charts.
 *
 * Anything that buckets households by status derives its keys from here via
 * `ADRESS_STATUS_KEYS`. Never copy the list — a copy that misses a key makes
 * those households disappear from a chart without any error (inbox #121).
 *
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 */

/** @type {Record<string, string>} */
const ADRESS_STATUS_LABELS = {
    planning: 'Inplannen',
    awaiting: 'In afwachting',
    planned: 'Ingepland',
    execute: 'Uitvoeren',
    'follow-up': 'Vervolgopdracht',
    completed: 'Afgerond',
    unreachable: 'Onbereikbaar',
}

/**
 * Every status key, in funnel order. The single list all counters, charts and
 * aggregations build on.
 *
 * @type {Array<string>}
 */
const ADRESS_STATUS_KEYS = Object.keys(ADRESS_STATUS_LABELS)

/**
 * @typedef {object} AdressStatusOption
 * @property {string} value - The value stored in Adresses.Status
 * @property {string} label - The Dutch label shown to the user
 */

/** @type {Array<AdressStatusOption>} */
const ADRESS_STATUS_OPTIONS = ADRESS_STATUS_KEYS
    .map((value) => ({ value, label: ADRESS_STATUS_LABELS[value] }))

export { ADRESS_STATUS_LABELS, ADRESS_STATUS_KEYS, ADRESS_STATUS_OPTIONS }
